export default "__VITE_ASSET__vmgt3jXr__"